import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CiNotification } from '../models/ci-notification';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';
import { CiNotificationFilter } from '../models/ci-notification-filter';
import { map } from 'rxjs/operators';
import { GoNotification } from '../models/go-notification.model';

const BATCH_FILTER: Partial<CiNotificationFilter> = {
  PageSize: 1000,
  PageNumber: 0,
};

@Injectable({
  providedIn: 'root'
})
export class BellNotificationService {

  notificationApi: string;
  batchFilter: Partial<CiNotificationFilter> = BATCH_FILTER;
  _reloadNotifiactions: Subject<boolean> = new Subject();
  get reloadNotifiactions(): Observable<boolean> {
    return this._reloadNotifiactions.asObservable();
  }

  private _urlGoNotification: GoNotification;

  setReloadNotifiactions() {
    this._reloadNotifiactions.next(true);
  }

  constructor(
    private http: HttpClient
  ) {
    this.notificationApi = environment.notificationUrl;
  }

  private reloadBatch(): void {
    this.batchFilter = BATCH_FILTER;
  }

  private parseFiltersToString(filter?: Partial<CiNotificationFilter>): HttpParams {
    this.reloadBatch();
    let result: HttpParams = new HttpParams();
    if (filter === undefined) {
      filter = {} as CiNotificationFilter;
    }
    filter = { ...this.batchFilter, ...filter };
    const filters = [];
    for (let key of Object.keys(filter)) {
      if (filter[key] !== undefined && filter[key] !== null && filter[key] !== '') {
        // filters.push([key, filter[key]].join('='));
        result = result.append(key, filter[key]);
      }
    }
    return result;
  }

  getAllNotifications(filter?: Partial<CiNotificationFilter>): Observable<CiNotification[]> {
    let filters = this.parseFiltersToString(filter);
    return this.http.get<CiNotification[]>(`${this.notificationApi}messages`, { params: filters })
      .pipe(
        map(notifications => {
          notifications.map(notification => {
            notification.receiveDate = new Date(notification.receiveDate);
            notification.registrationDate = new Date(notification.registrationDate);
            notification.dsRowClassNames = notification.wasSeen ? '' : 'ds-row-primary-text ds-row-primary-background';
          })
          return notifications;
        }),
      );
  }

  loadNotifications(filterIn?: Partial<CiNotificationFilter>): Observable<CiNotification[]> {
    const filter: Partial<CiNotificationFilter> = {...{
      PageSize: 5,
      PageNumber: 0,
      WasSeen: false,
      OrderBy: 'registrationDate',
      IsAscending: false
    }, ...(filterIn || {})};
    return this.getAllNotifications(filter);
  }

  getNotificationsCount(): Observable<number> {
    return this.http.get<number>(`${this.notificationApi}messages/count`);
  }

  sendNotificationReceive(id: string): Observable<any> {
    return this.http.put<any>(`${this.notificationApi}messages/setreceived`, { id });
  }

  sendNotificationSeen(id: string): Observable<any> {
    return this.http.put<any>(`${this.notificationApi}messages/setseen`, { id });
  }

  deleteNotification(id: string): Observable<any> {
    return this.http.delete<any>(`${this.notificationApi}messages/${id}`);
  }

  getIsCorporation(): Observable<boolean> {
    return this.http.get<boolean>(`${this.notificationApi}account/iscorporation`);
  }

  setUrlGoNotification(urls: GoNotification) {
        this._urlGoNotification = urls;
  }

  isSetUrlGoNotification(): boolean {
    return this._urlGoNotification != null;
  }

  urlGoNotification(modul: string): string {
    modul = modul.trim().toUpperCase();
    return this._urlGoNotification?.nodes.find(x => x.modul === modul)?.url || this._urlGoNotification?.urlDefault;
  }
}
